export const model = {
    id: null,
    day: '', 
    comment: '', 
    index: '',
    time: '', 
    created_at: '',
    updated_at: ''
};
